export { default as Edit } from 'inpc/components/list/actions/InpcActionEdit';



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/list/actions/index.js